import React from 'react'

import { getValueFormat } from '@baurine/grafana-value-formats'
import { Typography } from '@tidbcloud/uikit'

export function formatValue<T>(
  row: T,
  key: keyof T,
  unit: string
): JSX.Element {
  const formatFn = getValueFormat(unit)
  const val = row[key]
  if (typeof val !== 'number') {
    return <></>
  }

  const fmtVal = unit === 'short' ? formatFn(val, 0, 1) : formatFn(val, 1)
  return (
    <Typography w={80} variant='body-lg'>
      {fmtVal}
    </Typography>
  )
}
